// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as CountryHook from "../hook/CountryHook.bs.js";
import * as CountryProvider from "../context/CountryProvider.bs.js";
import * as CircularLoader$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/CircularLoader.bs.js";
import * as ErrorDisplayComponent$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/components/custom/error/ErrorDisplayComponent.bs.js";

function CountryConfigCmp(Props) {
  var children = Props.children;
  var country_config = CountryHook.useCountryConfig(undefined);
  console.log(country_config);
  switch (country_config.TAG | 0) {
    case /* Loading */0 :
        return React.createElement(CircularLoader$Catalyst.make, {});
    case /* Live */1 :
        return React.createElement(CountryProvider.make, CountryProvider.makeProps({
                        country: country_config._0
                      }, Curry._1(children, undefined), undefined));
    case /* Error */2 :
        return React.createElement(ErrorDisplayComponent$Catalyst.make, {
                    error: country_config._0
                  });
    
  }
}

var make = CountryConfigCmp;

export {
  make ,
  
}
/* react Not a pure module */
